<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>商户余额查询</h1>
        <p></p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>TRANS0308</td></tr>
          <tr><td>产品编号</td><td>proCd</td><td>String（15）</td><td>是</td><td>固定：tran 或者agent</td></tr>
          <tr><td>费率通道</td><td>chanelType</td><td>String（32）</td><td>是</td><td>固定：1</td></tr>
          <tr><td>商户编号</td><td>mchtCd</td><td>String(15)</td><td>是</td><td></td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000，失败：返回具体的响应码</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>可用金额</td><td>addMoney1</td><td>String（32）</td><td>是</td><td>元</td></tr>
          <tr><td>待结算金额</td><td>addMoney2</td><td>String（32）</td><td>是</td><td>元</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'Shyecx',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [{'url': '/interface/fz', 'name': '分账'},
        {'url': '/interface/cx', 'name': '交易查询'},
        {'url': '/interface/shyecx', 'name': '商户余额查询'},
        {'url': '/interface/qb', 'name': '钱包代付'}]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/shyecx.vue